export function getElementRef(rootEl, templateName, optionTemplates = {}) {
    let element = rootEl.querySelector(`[data-${templateName}]`)
    if (!element) {
        const buffer = document.createElement('div')
        buffer.innerHTML = optionTemplates[`${templateName}Template`]
        element = buffer.firstElementChild
        rootEl.appendChild(element)
    }
    return element
}